import http from '@root/utils/axios/admin';

let state = {
    NotificationsList: [],
}

let actions = {

    fetchNotificationsList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/notifications', { params: filter }).then((response) => {
                commit('setNotificationsList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    setReadNotifications({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/subscriber/read-notifications', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            })
        });
    },
}


let mutations = {
    setNotificationsList(state, data) {
        state.NotificationsList = data;
    },
}

export default {
    state,
    actions,
    mutations
}